import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchPolicies = createAsyncThunk(
  "policies/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosPrivate.get(api.getPolicyActiveApi);
      return res?.data?.data?.data ?? [];
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Fetch policies failed"
      );
    }
  }
);

const policiesSlice = createSlice({
  name: "policies",
  initialState: {
    list: [],
    loading: false,
    error: null,
  },
  reducers: {
    resetPoliciesState: (state) => {
      state.list = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPolicies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPolicies.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchPolicies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { resetPoliciesState } = policiesSlice.actions;
export default policiesSlice.reducer;
